import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrl: './dropdown.component.scss',
})
export class DropdownComponent {
  @Input() placeholder: string;

  @Input() options: any[];

  @Input() optionLabel: string;

  @Input() header: string;

  @Input() active: string;

  @Input() disabled: string;

  @Input() maxHeight: string = '20vh';

  // align menu value: dropdown-menu-end
  @Input() align: string;

  //Color Value; primary, secondary, success, danger, warning, info, light, dark
  @Input() color: string;

  //Size Value; xs,sm, md, lg
  @Input() size: string = 'md';

  @Input() icon: string;

  @Input() grouped: boolean = false;

  @Input() groupHeader: string;

  // groupHeaderStyle Value; text-primary, text-secondary, text-success, text-danger, text-warning, text-info, text-light, text-dark / bg-primary, bg-secondary, bg-success, bg-danger, bg-warning, bg-info, bg-light, bg-dark
  @Input() groupHeaderStyle: string;

  @Input() groupList: string;

  @Output() itemClickedEvent = new EventEmitter<any>();

  itemClicked(item: any): void {
    this.itemClickedEvent.emit(item);
  }
}
